/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
import type { CustomFieldData } from './CustomFieldData';
export type UpdateClientPayload = {
    firstName?: string;
    lastName?: string;
    gender?: UpdateClientPayload.gender;
    email?: string | null;
    phoneNumber?: string | null;
    address?: Address | null;
    isActive?: boolean;
    customFieldData?: Array<CustomFieldData>;
    notes?: string;
    personalMessage?: string;
};
export namespace UpdateClientPayload {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

